var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import CommonSalesActions from "@redux/feature/Common/action/commonAction";
import { PARTNER_CLIENT_SUMMARY, PARTNER_DROPDOWN_CLEAR, PARTNER_REVENUE_SUMMARY, SET_PARTNER_ACCOUNTS, SET_SELECTED_PARTNER, } from "../interface/IPartnerSummaryReducer";
var PartnerSummaryActions = /** @class */ (function (_super) {
    __extends(PartnerSummaryActions, _super);
    function PartnerSummaryActions() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.setPartnerAccounts = function (partnerAccounts, type) {
            console.log("data-fromaction", partnerAccounts);
            _this.dispatch({
                type: SET_PARTNER_ACCOUNTS,
                payload: { partnerAccounts: partnerAccounts },
                reducerName: type,
            });
        };
        return _this;
    }
    PartnerSummaryActions.prototype.clearSelectedDropdown = function (data, type) {
        this.dispatch({
            type: PARTNER_DROPDOWN_CLEAR,
            payload: { clearSelectedDropdown: data },
            reducerName: type,
        });
    };
    PartnerSummaryActions.prototype.setPartnerClientSummary = function (clientSummary, type) {
        this.dispatch({
            type: PARTNER_CLIENT_SUMMARY,
            payload: { partnerClientSummaryEntity: clientSummary },
            reducerName: type,
        });
    };
    PartnerSummaryActions.prototype.setPartnerRevenueSummary = function (revenueSummary, type) {
        this.dispatch({
            type: PARTNER_REVENUE_SUMMARY,
            payload: { partnerRevenueSummaryEntity: revenueSummary },
            reducerName: type,
        });
    };
    PartnerSummaryActions.prototype.setSelectedPartner = function (searchData, type) {
        this.dispatch({
            type: SET_SELECTED_PARTNER,
            payload: { selectedPartner: searchData },
            reducerName: type,
        });
    };
    return PartnerSummaryActions;
}(CommonSalesActions));
export default PartnerSummaryActions;
